<template>
	<v-card :key="page_key" :loading="loading" class="ma-2 elevation-0" color="grey lighten-4">
		<v-card-title class="secondary--text">Practice Search Tools </v-card-title>
		<v-row>
			<v-card-text>
				<v-row class="pa-2 justify-center text-center">
					<v-card
						v-for="(condition, key) in orConditions"
						:key="'or_' + key"
						class="mt-3 pl-5 ml-5 justify-center text-center mr-5 pr-5 pb-3"
						justify="center"
						align="center"
						:elevation="2"
						width="100%"
					>
						<v-card-actions>
							<v-btn x-small color="primary" absolute right fab elevation="2" @click="removeOrCondition(key)">
								<v-icon>mdi-minus</v-icon>
							</v-btn>
						</v-card-actions>
						<v-card-text>
							<v-card
								v-for="(and_condition, and_key) in condition"
								:key="'and_' + and_key"
								color="grey lighten-2"
								class="mt-2 pl-5 ml-5 justify-center text-center ml-5 mr-5 pr-5 pb-3 mb-3"
								justify="center"
								align="center"
								:elevation="3"
								width="100%"
							>
								<v-card-actions>
									<v-btn x-small color="primary" absolute right fab elevation="2" @click="removeAndCondition(and_key, key)">
										<v-icon>mdi-minus</v-icon>
									</v-btn>
								</v-card-actions>
								<v-card-text v-if="and_condition.type == 'none'" class="pl-5">
									<v-select
										v-model="and_condition.type"
										class="pa-3 pl-5"
										dense
										label="Filter by"
										value="'none'"
										:items="['attribute']"
										@input="a => onChangeFilterType(a, and_key, key)"
									></v-select>
								</v-card-text>
								<v-card-title v-if="and_condition.type != 'none'" class="pl-5"> filter by {{ and_condition.type }} </v-card-title>

								<v-card-text v-if="and_condition.type == 'industry'">
									<v-row>
										<v-col>
											<v-select
												v-model="and_condition.industry"
												dense
												label="industry"
												:items="industriesOptions"
												item-text="industry"
												item-value="industry"
												@input="a => onUpdateIndustryCondition(a, and_key, key)"
											></v-select>
										</v-col>
									</v-row>
								</v-card-text>
								<v-card-text v-if="and_condition.type == 'attribute'">
									<v-row>
										<v-col>
											<v-select
												v-model="and_condition.fieldToMatch"
												:item-value="'value'"
												item-text="text"
												label="attribute"
												:items="byFieldsNames"
											></v-select>
										</v-col>

										<v-col v-if="typeof and_condition.fieldToMatch == 'string'" class="font-weight-bold">
											<v-select
												v-model="and_condition.comparator"
												persistent-hint
												:item-value="'value'"
												item-text="text"
												hint="select comparison"
												label="comparator"
												:items="comparatorOptions"
											></v-select>
										</v-col>

										<v-col v-if="typeof and_condition.fieldToMatch == 'object' && and_condition.fieldToMatch.arguments.length > 0">
											<v-row>
												<v-col v-for="(argument, argument_index) in and_condition.fieldToMatch.arguments" :key="key + and_key + argument_index">
													<!-- custom input here -->
													<v-text-field v-if="argument.type == 'string'" v-model="argument.value" dense label="value"></v-text-field>

													<v-select
														v-if="argument.type == 'list'"
														v-model="argument.value"
														:multiple="argument.multiple"
														dense
														persistent-hint
														:hint="'hint' in argument ? argument.hint : 'select option'"
														label="option"
														:items="argument.options"
													></v-select>

													<v-select v-if="argument.type == 'boolean'" v-model="argument.value" :items="['NO', 'YES']"></v-select>

													<v-menu
														v-if="argument.type == 'date_selector'"
														ref="menu"
														v-model="argument.menu"
														:close-on-content-click="true"
														transition="scale-transition"
														offset-y
														min-width="290px"
													>
														<template #activator="{ on, attrs }">
															<v-text-field
																v-model="argument.value"
																label="Date"
																type="date"
																hint="Select or type the date (YYYY/MM/DD)"
																persistent-hint
																v-bind="attrs"
																v-on="on"
															></v-text-field>
														</template>
														<v-date-picker ref="picker" v-model="argument.value" min="1950-01-01"></v-date-picker>
													</v-menu>
													<v-select v-if="argument.type == 'date_comparator'" v-model="argument.value" :items="dateComparatorOptions"></v-select>
													<v-card-text v-if="argument.type == 'constant'" readonly :value="argument.value" class="font-weight-bold">{{
														argument.value
													}}</v-card-text>
												</v-col>
											</v-row>
										</v-col>

										<v-col v-else-if="typeof and_condition.fieldToMatch == 'string'">
											<v-text-field v-model="and_condition.valueToMatch" dense label="value"></v-text-field>
										</v-col>
									</v-row>
								</v-card-text>
								<v-row justify="center" align="center" class="pa-2">
									<v-btn
										:disabled="and_key == condition.length - 1 ? false : true"
										:color="and_key == condition.length - 1 ? 'primary' : ''"
										fab
										bottom
										absolute
										class="font-weight-bold mt-n7"
										x-small
										@click="newAndCondition(key)"
										>{{ and_key == condition.length - 1 ? '+' : '' }}AND</v-btn
									>
								</v-row>
								<!-- end AND card -->
							</v-card>

							<v-row justify="center" align="center" class="pa-3 mt-0 pt-0">
								<v-btn
									:disabled="key == orConditions.length - 1 ? false : true"
									:color="key == orConditions.length - 1 ? 'primary' : ''"
									fab
									bottom
									absolute
									class="font-weight-bold mt-n7"
									x-small
									@click="newOrCondition"
									>{{ key == orConditions.length - 1 ? '+' : '' }}OR</v-btn
								>
							</v-row>
						</v-card-text>
					</v-card>
				</v-row>

				<v-row class="pa-2">
					<v-col>
						<v-btn :loading="loading" @click="doSearch = true">Search</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-row>

		<v-row>
			<v-card-text v-if="practices.length > 0">
				<v-row>
					<v-col>
						<v-divider></v-divider>
						<v-divider></v-divider>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-data-table
							:headers="[
								{ text: 'actions', value: 'id' },
								{ text: 'email', value: 'email' },
								{ text: 'createdAt', value: 'createdAt' },
							]"
							fixed-header
							:items="practices"
							:items-per-page="5"
							class="elevation-1"
						>
							<!-- <template v-slot:item.experience="{ item }" >
                <div v-if="item && 'experience' in item">
                  <v-list-item v-for="(value,field) in item.experience" :key="field">
                    <v-chip>{{field}} : {{value}}</v-chip>
                  </v-list-item>
                </div>
                <div v-else><v-chip color="red">Not Provided</v-chip></div>
              </template> -->
							<template #item.id="{ item }">
								<v-row>
									<v-btn class="white--text mx-1" color="primary" rounded :aria-label="item" @click="viewpractice(item)">view practice</v-btn>
									<v-btn class="white--text mx-1" color="secondary" rounded :aria-label="item" @click="enableImpersonation(item.createdBy)">impersonate</v-btn>
								</v-row>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-card-text>

			<v-card-actions class="pa-3 justify-center text-center">
				<v-row class="pl-2" justify="center" align="center">
					<v-col class="justify-center text-center">
						<vue-json-to-csv
							:json-data="practiceCSVData"
							:labels="practiceFieldLabels"
							csv-title="practice Search Tool Export"
							@success="val => handleCSVSuccess(val)"
							@error="val => handleCSVError(val)"
						>
							<v-btn class="white--text" color="primary" rounded :disable="false">Export Results</v-btn>
						</vue-json-to-csv>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-row>
	</v-card>
</template>

<script>
import moment from 'moment';
import { bus } from '@/main';
import { Parser } from 'json2csv';
import router from '@/router';
import VueJsonToCsv from 'vue-json-to-csv';

import axios from 'axios'; //be able to make requests.
import store from '@/store'; //expose the vuex store, jwt token and user.
import { getAllIndustriesProfessions, setImpersonatedUser } from '@utils';

/*
TODO implement these features.
improve design
locations,

TODO edit practice profile feature -< ONGOING


*/

/*
Search Tool - Jaco Kotze 2021
This tool serves as a dashboard device for admin staff in LocumBase to perform serch queries on practices.

The tools design and flow is inspired by SendInBlue contact search tool.

A search is comprised of OR blocks, ie the entire database is queried with the contents of each block and the final combined unique result is shown.
Each OR Block may contain one or more AND blocks.
An AND BLOCK functions as a logical and on results, ie an OR BLOCK may have two ANDS : email like "john@gmail.com" AND "approved" is false.

Further attributes are written in either specialised or generic search types.
IE, strings use the classic "contains" "starts with" "ends with" "exactly matches" conditions etc
Specialised or custom search types/attributes may be created. This allows the tool to for instance allow special searches with custom filter logic.
Specialised search types function as shorthands for various searches, ie "is approved" functions as the shorthand for boolean search type "approved == true"
  It creates less clicks for user and is more intuitive.
Further specialised searches allow custom arguments in the GUI, its possible to specify what type of arguments in order are asked for.
IE, one can specify no arguments or example 'a string' then 'a boolean' be arguments. OR 'classic string comparison' such as 'contains' etc be selectable.
These arguments types, and their values are passed to the custom specialised search type method when it is called for usage by that method. The order of the arguments in the method are in the order the arguments are defined.

The order the SEARCH is performed is as follows :
1. a core search is performed. this fetches *all* practices.
2. for each OR block each AND sub-block inside is applied to the ALL list,
3. for each AND sub-block the logic checks which condition is being used, if a custom it calls the custom method passing in the arguments that are defined by that custom search type.
4. IF the entire OR block is true then the practice is pushed to final results.
*/

export default {
	name: 'PracticeSearchTool',
	components: { VueJsonToCsv },
	data: () => ({
		industriesConfigsObj: store.getters.configs.industries,
		industryOptionsItems: null,
		page_key: 0,
		loading: false,
		doSearch: false,

		results_headers: [{ text: 'email', value: 'email' }],

		//all of the OR blocks that will be used. type :"none" is default state for empty block
		orConditions: store.getters.adminLastSearch?.orConditions || [[{ type: 'none' }]],

		//the classic string comparison operators.
		comparatorOptions: ['exactly matches', 'contains', 'does not contain', 'starts with', 'ends with'],

		//the classic right hand side of a list comparison, ie ["lefthand side" "righthand side" "list-attribute"] or ["john" "occurs in" "manager names"]
		rhlistComparatorOptions: ['occurs in', 'does not occur in'],

		//classic date comparison operators. using moment.js
		dateComparatorOptions: ['after', 'before', 'between'],
		//the final list of results to be populated in this field :
		practices: [],

		practiceFieldLabels: {
			name: { title: 'Name' },
			email: { title: 'Email' },
			contact: { title: 'Contact' },
			address: { title: 'Address' },
			bank_account: { title: 'Bank Account' },
			practice_number: { title: 'Practice Number' },
			professionalInsuranceCover: { title: 'Malpractice Insurance' },
			industry: { title: 'Industry' },
			managers: { title: 'Managers' },
			status: { title: 'Status' },
			terms_conditions: { title: 'Terms Conditions' },
			vat_no: { title: 'VAT Number' },
			working_hours: { title: 'Working Hours' },
			id: { title: 'ID' },
			tenantId: { title: 'Tenant Id' },
			isDeleted: { title: 'Deleted' },
			isActive: { title: 'Active' },
			approved: { title: 'Approved' },
			createdAt: { title: 'Created At' },
			createdBy: { title: 'Created By' },
			updatedAt: { title: 'Created At' },
			updatedBy: { title: 'Created by' },
		},
	}),
	//those fields that can be selected for search in the tool.
	//basic string type fields are strings only.
	//specialsied fields use the vue list item design, where value is a object to defined how the search type works :
	// {
	//   arguments : [...{
	//     type : <string> the type of the argument, ie list string, boolean, numbe etc.
	//     hint : <string> the string hint to show on the input component.
	//   }],
	//   f : <string> the name of the function in this object which should be called with the argument values. MUST be unique, prepend "f" for readability.
	// }
	computed: {
		practiceCSVData() {
			const data = [];
			this.practices.forEach(practice => {
				const parsed = {};
				for (const key in practice) {
					if (key == 'address') {
						let string = '';
						for (const subKey in practice[key]) {
							string += `${practice[key][subKey]}, `;
						}
						parsed[key] = string;
					} else if (key == 'bank_account') {
						let string = '';
						for (const subKey in practice[key]) {
							string += `${subKey}: ${practice[key][subKey]}, `;
						}
						parsed[key] = string;
					} else if (key == 'short_bio') {
						let string = `${practice[key]}`;
						parsed[key] = string;
					} else if (key == 'working_hours') {
						let string = '';
						for (const subKey in practice[key]) {
							string += `${subKey}: {`;
							for (const subInnerKey in practice[key][subKey]) {
								string += `${subInnerKey}: ${practice[key][subKey][subInnerKey]}, `;
							}
							string += `}, `;
						}
						parsed[key] = string;
					} else if (key == 'managers') {
						let string = '';
						for (const subKey in practice[key][0]) {
							string += `${subKey}: ${practice[key][0][subKey]}, `;
						}
						parsed[key] = string;
					} else parsed[key] = practice[key];
				}
				data.push(parsed);
			});

			return data;
		},

		byFieldsNames() {
			return [
				'practice_number',
				'short_bio',
				{
					text: 'industry',
					value: {
						arguments: [
							{ type: 'list', multiple: false, hint: 'comparator', options: this.rhlistComparatorOptions, value: null },
							{ type: 'list', multiple: true, hint: 'select industry', options: this.computedIndustries, value: null },
						],
						f: 'findustry',
						findustry: function findustry(practice, comparator, industryies) {
							if ('industry' in practice) {
								comparator = comparator.value;
								industryies = industryies.value;
								if (comparator == 'occurs in') {
									return industryies.findIndex(industry => industry == practice.industry) > -1;
								} else {
									//does not occur in
									return industryies.findIndex(industry => industry == practice.industry) == -1;
								}
							}
							return false;
						},
					},
				},
				'isDeleted',
				'updatedBy',
				'email',
				'createdBy',
				'locations',
				{ divider: true },

				{ header: 'Name' },
				'name',
				{ divider: true },

				{ header: 'Last Updated' },
				{
					text: 'last updated on',
					value: {
						arguments: [{ type: 'date_selector', value: null }],
						f: 'flastUpdatedOn',
						flastUpdatedOn: function flastUpdatedOn(practice, lastUpdatedFrom) {
							return 'updatedAt' in practice && moment(moment(practice.updatedAt).format('YYYY-MM-DD')).isSame(lastUpdatedFrom.value);
						},
					},
				},
				{
					text: 'last updated after',
					value: {
						arguments: [{ type: 'date_selector', value: null }],
						f: 'flastUpdatedAfter',
						flastUpdatedAfter: function flastUpdatedAfter(practice, lastUpdatedFrom) {
							return 'updatedAt' in practice && moment(moment(practice.updatedAt).format('YYYY-MM-DD')).isAfter(lastUpdatedFrom.value);
						},
					},
				},
				{
					text: 'last updated before',
					value: {
						arguments: [{ type: 'date_selector', value: null }],
						f: 'flastUpdatedBefore',
						flastUpdatedBefore: function flastUpdatedBefore(practice, lastUpdatedFrom) {
							return 'updatedAt' in practice && moment(moment(practice.updatedAt).format('YYYY-MM-DD')).isBefore(lastUpdatedFrom.value);
						},
					},
				},

				{ divider: true },

				{ header: 'Created At' },
				{
					text: 'created on',
					value: {
						arguments: [{ type: 'date_selector', value: null }],
						f: 'flastCreatedOn',
						flastCreatedOn: function flastCreatedOn(practice, lastUpdatedFrom) {
							return 'createdAt' in practice && moment(moment(practice.createdAt).format('YYYY-MM-DD')).isSame(lastUpdatedFrom.value);
						},
					},
				},
				{
					text: 'created after',
					value: {
						arguments: [{ type: 'date_selector', value: null }],
						f: 'fcreatedAfter',
						fcreatedAfter: function fcreatedAfter(practice, lastUpdatedFrom) {
							return 'createdAt' in practice && moment(moment(practice.createdAt).format('YYYY-MM-DD')).isAfter(lastUpdatedFrom.value);
						},
					},
				},
				{
					text: 'created before',
					value: {
						arguments: [{ type: 'date_selector', value: null }],
						f: 'fCreatedBefore',
						fCreatedBefore: function fCreatedBefore(practice, lastUpdatedFrom) {
							return 'createdAt' in practice && moment(moment(practice.createdAt).format('YYYY-MM-DD')).isBefore(lastUpdatedFrom.value);
						},
					},
				},

				{ divider: true },

				{ header: 'Approved' },
				{
					text: 'is approved',
					value: {
						arguments: [],
						f: 'fisApproved',
						fisApproved: function fisApproved(practice) {
							return 'approved' in practice && practice.approved;
						},
					},
				},
				{
					text: 'is not approved',
					value: {
						arguments: [],
						f: 'fisNotApproved',
						fisNotApproved: function fisNotApproved(practice) {
							return !('approved' in practice) || !practice.approved;
						},
					},
				},
				{ divider: true },
				'id',
				'terms_conditions',
				'contact',
				// "createdAt",
				{ header: 'Address' },
				{
					text: 'building_name',
					value: {
						arguments: [{ type: 'string', value: null }],
						f: 'fBuilding_Name',
						fBuilding_Name: function fBuilding_Name(practice, building_name) {
							return 'address' in practice && 'building_name' in practice.address && practice.address.building_name == building_name.value;
						},
					},
				},
				{
					text: 'country',
					value: {
						arguments: [{ type: 'string', value: null }],
						f: 'fcountry',
						fcountry: function fcountry(practice, country) {
							return 'address' in practice && 'country' in practice.address && practice.address.country == country.value;
						},
					},
				},
				{
					text: 'postal_code',
					value: {
						arguments: [{ type: 'string', value: null }],
						f: 'fpostal_code',
						fpostal_code: function fpostal_code(practice, postal_code) {
							return 'address' in practice && 'postal_code' in practice.address && practice.address.postal_code == postal_code.value;
						},
					},
				},
				{
					text: 'province',
					value: {
						arguments: [{ type: 'string', value: null }],
						f: 'fprovince',
						fprovince: function fprovince(practice, province) {
							return 'address' in practice && 'province' in practice.address && practice.address.province == province.value;
						},
					},
				},
				{
					text: 'region',
					value: {
						arguments: [{ type: 'string', value: null }],
						f: 'fregion',
						fregion: function fregion(practice, region) {
							return 'address' in practice && 'region' in practice.address && practice.address.region == region.value;
						},
					},
				},
				{
					text: 'street',
					value: {
						arguments: [{ type: 'string', value: null }],
						f: 'fstreet',
						fstreet: function fstreet(practice, street) {
							return 'address' in practice && 'street' in practice.address && practice.address.street == street.value;
						},
					},
				},
				{
					text: 'suburb',
					value: {
						arguments: [{ type: 'string', value: null }],
						f: 'fsuburb',
						fsuburb: function fsuburb(practice, suburb) {
							return 'address' in practice && 'suburb' in practice.address && practice.address.suburb == suburb.value;
						},
					},
				},
				{
					text: 'unit_no',
					value: {
						arguments: [{ type: 'string', value: null }],
						f: 'funit_no',
						funit_no: function funit_no(practice, unit_no) {
							return 'address' in practice && 'unit_no' in practice.address && practice.address.unit_no == unit_no.value;
						},
					},
				},
				{ divider: true },

				'isActive',
				'qualifications',
			];
		},
		computedIndustries() {
			return this.industriesOptions.map(industry => industry.industry);
		},
		industriesOptions() {
			return this.industryOptionsItems;
		},
	},
	watch: {
		doSearch: async function (val) {
			if (val) {
				this.loading = true;
				await this.on_search();
				this.doSearch = false;
			}
		},
	},
	async mounted() {
		this.industryOptionsItems = getAllIndustriesProfessions(this.industriesConfigsObj);
		// if a search is found apply the search when getting to component
		const search = store.getters.adminLastSearch;
		if (search && (search.orConditions != [] || search.core_search != [])) this.on_search(search);
	},
	methods: {
		// called if the CSV export/creation fails
		handleCSVError(value) {
			console.error('CSV EXPORT ERROR', value);
		},

		// called if the CSV export/creation was successfull
		handleCSVSuccess() {},

		//powerful method used internally, on EXPORT of the results list the result is copied for user to clipboard using this trick.
		// --not created by me (Jaco Kotze), original credit not known.
		copyTextToClipboard(text) {
			var textArea = document.createElement('textarea');

			//
			// *** This styling is an extra step which is likely not required. ***
			//
			// Why is it here? To ensure:
			// 1. the element is able to have focus and selection.
			// 2. if the element was to flash render it has minimal visual impact.
			// 3. less flakyness with selection and copying which **might** occur if
			//    the textarea element is not visible.
			//
			// The likelihood is the element won't even render, not even a
			// flash, so some of these are just precautions. However in
			// Internet Explorer the element is visible whilst the popup
			// box asking the user for permission for the web page to
			// copy to the clipboard.
			//

			// Place in the top-left corner of screen regardless of scroll position.
			textArea.style.position = 'fixed';
			textArea.style.top = 0;
			textArea.style.left = 0;

			// Ensure it has a small width and height. Setting to 1px / 1em
			// doesn't work as this gives a negative w/h on some browsers.
			textArea.style.width = '2em';
			textArea.style.height = '2em';

			// We don't need padding, reducing the size if it does flash render.
			textArea.style.padding = 0;

			// Clean up any borders.
			textArea.style.border = 'none';
			textArea.style.outline = 'none';
			textArea.style.boxShadow = 'none';

			// Avoid flash of the white box if rendered for any reason.
			textArea.style.background = 'transparent';

			textArea.value = text;

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				var successful = document.execCommand('copy');
				successful ? 'successful' : 'unsuccessful';
			} catch (err) {
				console.error('Unable to copy');
			}

			document.body.removeChild(textArea);
		},

		//export the results of the last search to clipboard in JSON format. uses a JSON library to per practice per attribute map data correctly to a JSON CSV acceptable format.
		//TODO : fix, does not work
		exportResults() {
			var input = this.practices;
			const fields = ['id', 'email', 'createdAt', 'name'];

			try {
				const parser = new Parser({ fields });
				const csv = parser.parse(input);
				this.copyTextToClipboard(csv);
			} catch (err) {
				console.error('jsonparser', err);
			}
		},

		viewpractice(practice) {
			store.commit('SET_ADMIN_VIEW_PRACTICE', practice); //refresh the users state. await it completed.
			bus.$emit('change-main-context', 'ViewPracticeProfile');
		},

		async enableImpersonation(id) {
			const success = await setImpersonatedUser('practice', id);
			if (!success) {
				return alert('User not found');
			}
			router.push('/practice/dashboard');
		},

		newOrCondition() {
			this.orConditions.push([{ type: 'none' }]);
			this.plus_page_key();
		},

		newAndCondition(orKey) {
			this.orConditions[orKey].push({ type: 'none' });
			this.plus_page_key();
		},

		removeOrCondition(key) {
			if (key > 0) {
				this.orConditions = [...this.orConditions.slice(0, key), ...this.orConditions.slice(key + 1)];
			} else {
				this.orConditions = [...this.orConditions.slice(1)];
			}
			if (this.orConditions.length == 0) {
				this.orConditions = [[{ type: 'none' }]];
			}
			this.plus_page_key();
		},

		removeAndCondition(andKey, orKey) {
			if (andKey > 0) {
				this.orConditions[orKey] = [...this.orConditions[orKey].slice(0, andKey), ...this.orConditions[orKey].slice(andKey + 1)];
			} else {
				this.orConditions[orKey] = [...this.orConditions[orKey].slice(1)];
			}
			if (this.orConditions[orKey].length == 0) {
				this.orConditions[orKey] = [{ type: 'none' }];
			}
			this.plus_page_key();
		},

		onChangeFilterType(value, andKey, orKey) {
			this.orConditions[orKey][andKey].type = value;
			this.plus_page_key();
		},

		onUpdateIndustryCondition(value, andKey, orKey) {
			this.orConditions[orKey][andKey].industry = value;
			this.plus_page_key();
		},

		onUpdateExpertiseCondition(value, index) {
			if (value.find(expertise => expertise == 'ALL')) {
				this.orConditions[index].expertise = ['ALL'];
			}
			this.plus_page_key();
		},

		async on_search(lastSearch = null) {
			this.plus_page_key();
			this.practices = [];
			const conditions = lastSearch ? lastSearch.orConditions : this.orConditions;
			const token = store.getters.jwtToken;
			await conditions.forEach(async OrBlock => {
				//those practices who matched that industry and expertise filter, for each does ALL other filters apply ?
				let result = (await axios.get(store.getters.getAPI + '/companies/', { headers: { Authorization: token } })).data.data.Items;
				let final = [];

				// make sure to store the last search query
				store.commit('SET_ADMIN_LAST_SEARCH', { core_search: [], orConditions: this.orConditions });

				await result.forEach(async practice => {
					var failedAny = await OrBlock.filter(condition => condition.type == 'attribute').some(attribute_match_condition => {
						if (typeof attribute_match_condition.fieldToMatch == 'string') {
							if (attribute_match_condition.comparator == 'exactly matches') {
								return !(
									attribute_match_condition.fieldToMatch in practice && attribute_match_condition.valueToMatch == practice[attribute_match_condition.fieldToMatch]
								);
							} else if (attribute_match_condition.comparator == 'contains') {
								return !(
									attribute_match_condition.fieldToMatch in practice &&
									practice[attribute_match_condition.fieldToMatch].indexOf(attribute_match_condition.valueToMatch) > -1
								);
							} else if (attribute_match_condition.comparator == 'does not contain') {
								return !(
									attribute_match_condition.fieldToMatch in practice &&
									practice[attribute_match_condition.fieldToMatch].indexOf(attribute_match_condition.valueToMatch) == -1
								);
							} else if (attribute_match_condition.comparator == 'starts with') {
								return !(
									attribute_match_condition.fieldToMatch in practice &&
									practice[attribute_match_condition.fieldToMatch].startsWith(attribute_match_condition.valueToMatch)
								);
							} else if (attribute_match_condition.comparator == 'ends with') {
								return !(
									attribute_match_condition.fieldToMatch in practice &&
									practice[attribute_match_condition.fieldToMatch].endsWith(attribute_match_condition.valueToMatch)
								);
							} else {
								console.error('unknown conditional comparator ' + attribute_match_condition.comparator);
								return true;
							}
						} else {
							const f_name = attribute_match_condition.fieldToMatch.f;

							return !attribute_match_condition.fieldToMatch[f_name](practice, ...attribute_match_condition.fieldToMatch.arguments);
						}
					}); //append more filters via a OR operator to this point, for left to right early exit. Return TRUE if the filter fails.

					if (!failedAny) {
						await final.push(practice);
					}
				});
				this.loading = false;
				//finally push the filter into here.
				this.practices.push(...final);
			});
		},

		plus_page_key() {
			this.page_key += 1;
		},
	},
};
</script>
